module.exports = __webpack_public_path__ + "img/comercio.c7da161e.png";